import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=666070ae&scoped=true&"
import script from "./ProductView.vue?vue&type=script&lang=js&"
export * from "./ProductView.vue?vue&type=script&lang=js&"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=666070ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666070ae",
  null
  
)

export default component.exports